module.exports = __webpack_public_path__ + "img/mobile_map_brasil_christmast.6e552e74.svg";